export const getTournamentStatus = (
  registrationStartedAt,
  registrationEndedAt
) => {
  const now = new Date()
  const startDate = new Date(registrationStartedAt)
  const endDate = new Date(registrationEndedAt)

  const getStatusType = () => {
    if (now < startDate) return 'upcoming'
    if (now >= startDate && now <= endDate) return 'open'
    return 'closed'
  }

  switch (getStatusType()) {
    case 'upcoming':
      return { text: 'Upcoming', color: '#4CAF50' }
    case 'open':
      return { text: 'Open', color: '#FFA900' }
    case 'closed':
      return { text: 'Closed', color: '#FF4444' }
    default:
      return { text: 'Unknown', color: '#999999' }
  }
}
